module.exports = __webpack_public_path__ + "img/partner.798ae642.png";